'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$19() {
  this.b5g = null;
  this.b5h = false;
}
export { $c_Lpresto_LoginPageView$$anon$19 as $c_Lpresto_LoginPageView$$anon$19 };
$p = $c_Lpresto_LoginPageView$$anon$19.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$19;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$19() {
}
export { $h_Lpresto_LoginPageView$$anon$19 as $h_Lpresto_LoginPageView$$anon$19 };
$h_Lpresto_LoginPageView$$anon$19.prototype = $p;
$p.P = (function() {
  if ((!this.b5h)) {
    this.b5g = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.b5h = true;
  }
  return this.b5g;
});
var $d_Lpresto_LoginPageView$$anon$19 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$19, "presto.LoginPageView$$anon$19", ({
  Mk: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_LoginPageView$$anon$19 as $d_Lpresto_LoginPageView$$anon$19 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$19.js.map
